// File: frontend/src/models/enums/ThemeEnum.ts
// Theme options matching backend Theme enum
export enum ThemeEnum {
  LIGHT = "LIGHT",
  DARK = "DARK",
  PAPER = "PAPER",
  TANGO = "TANGO",
  FLAMINGO = "FLAMINGO",
  COMOLOKKO = "COMOLOKKO",
  LOKUM = "LOKUM",
  MERCAN = "MERCAN",
  GOKYUZU = "GOKYUZU",
  // Dynamic theme: palette derived from the user's first favourite club.
  // Only selectable while the user has at least one favourite club with colours.
  TARAFTAR = "TARAFTAR",
}